import ChaptersCollection from 'collections/ChaptersCollection'

export default class ModuleModel extends Backbone.Model {

    preinitialize() {
        this.constructor.type = 'module'
        this.constructor.pluralType = 'modules'
    }

    initialize(data, {groupModel}) {
        this.groupModel = groupModel
    }

    getParent() {
        return this.getGroupModel()
    }

    getChildren() {
        if (this.id === 0) {
            return this.getGroupModel().getChaptersWithoutModule()
        }
        return new ChaptersCollection(
            this.getGroupModel().chapters.where({moduleId: this.id})
        )
    }

    getSiblings() {
        return this.getGroupModel().modules
    }

    getGroupModel() {
        return this.groupModel
    }

    getCrumblepathModel() {
        return new Backbone.Model({
            icon: 'module',
            label: this.get('title'),
            level: 'groups',
            path_id: `${this.getGroupModel().id}?module=${this.id}`,
        })
    }

    setSequence() {
        this.set({
            sequence: this.id === 0 ?
                Infinity :
                this.getGroupModel().chapters.find({moduleId: this.id}).get('sequence'),
        })
    }

}
